import { FilterOptions } from '../../../domain/filter/filter-options';

export const AnagraficaFilterModalInstanceComponent = {
    template: require('./anagrafica-filter-modal-instance.html'),
    controller: class AnagraficaFilterModalInstanceComponent {

        private filter: Record<string, string>;
        private filterOptions: FilterOptions;

        private resolve: any;
        private close: any;
        private dismiss: any;

        $onInit(): void {
            this.filterOptions = this.resolve.filterOptions;
            this.filter = this.filterOptions.toRecord();
        }

        clearFilter() {
            this.filterOptions.clear();
            this.filter = this.filterOptions.toRecord();
        }

        ok() {
            this.filterOptions.setValues(this.filter);
            this.close({ $value: this.filterOptions });
        }

        cancel() {
            this.dismiss();
        }
    },
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/anagrafica-filter-modal-instance/anagrafica-filter-modal-instance.ts